<template>
  <div :class="device.desktop ? `profil pa-6` : `profil pa-2`">
    <v-row class="justify-center ma-0">
      <v-col
        :cols="device.desktop ? 5 : 12"
        class="pa-0"
      >
        <div class="profil-panel">
          <div class="profil-panel-header">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-account-circle-outline</v-icon>
            <span class="profil-panel-title">PROFIL PENGGUNA</span>
          </div>

          <!-- Avatar & identitas -->
          <div class="profil-identity">
            <v-hover>
              <template v-slot:default="{ hover }">
                <div
                  class="profil-avatar-wrap"
                  :class="hover ? `profil-avatar-wrap--hover` : ``"
                >
                  <v-avatar size="120">
                    <v-img
                      :src="foto"
                      :lazy-src="foto"
                    ></v-img>
                  </v-avatar>
                  <div
                    class="profil-avatar-overlay"
                    v-show="hover"
                  >
                    <v-btn
                      icon
                      dark
                      @click="uploadFoto"
                    >
                      <v-icon>mdi-camera</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-hover>

            <div class="profil-name">{{ record.name || "-" }}</div>
            <div class="profil-email">{{ record.email || "-" }}</div>
            <div
              class="profil-level"
              v-if="record.authent"
            >
              <v-icon
                x-small
                color="#93c5fd"
              >mdi-shield-account-outline</v-icon>
              <span>{{ record.authent }}</span>
            </div>
          </div>

          <div class="profil-divider"></div>

          <!-- Form -->
          <div class="profil-form">
            <v-text-field
              label="Nama Lengkap"
              dark
              color="#60a5fa"
              background-color="#0a1224"
              v-model="record.name"
              dense
              outlined
              persistent-hint
              hint="Nama yang tampil pada aplikasi"
              prepend-inner-icon="mdi-account-outline"
            ></v-text-field>

            <v-text-field
              label="NIP|EMAIL"
              dark
              color="#60a5fa"
              background-color="#0a1224"
              v-model="record.email"
              dense
              outlined
              disabled
              persistent-hint
              hint="Email tidak dapat diubah, hubungi administrator"
              prepend-inner-icon="mdi-email-outline"
              class="mt-4"
            ></v-text-field>

            <div class="profil-form-footer">
              <div class="profil-form-note">
                <v-icon
                  x-small
                  color="#94a3b8"
                >mdi-information-outline</v-icon>
                Klik foto untuk mengganti avatar anda
              </div>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                dark
                class="profil-btn-save"
                @click="fetchUpdate"
              >
                <v-icon
                  left
                  small
                >mdi-content-save-outline</v-icon>
                Simpan
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "perusahaan-index",
  data: () => ({
    foto: "/",
  }),
  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "records",
      "record",
      "loading",
      "event",
      "snackbar",
    ]),
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/",
      title: "PROFIL",
      subtitle: "Manajemen Profil Pengguna",
      breadcrumbs: [
        {
          text: "Utility",
          disabled: true,
          href: "",
        },
        {
          text: "Profil Pengguna",
          disabled: false,
          href: "",
        },
      ],
      add: false,
      edit: false,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
      },
      showtable: false,
    });

    this.fetchRecord();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "initUploadLibrary",
      "setRecord",
    ]),
    fetchRecord: async function () {
      let { data } = await this.http.get("api/user-info");

      this.setRecord(data);

      this.foto = data.avatar_path;
    },
    fetchUpdate: async function () {
      try {
        let {
          data: { status, message, data },
        } = await this.http.post("api/utility/update-profil", this.record);

        if (!status) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;

        this.record = data;
        this.fetchRecord();
        this.getUserInfo();
      } catch (error) {
        this.snackbar.color = "red";
        this.snackbar.text = error.data.errors[0].message;
        this.snackbar.state = true;
      }
    },

    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "avatars",
        },
        callback: (response) => {
          setTimeout(() => {
            this.foto = response.path;
            this.record.avatar = response.name;
          }, 1000);
        },
      });
    },
  },
};
</script>

<style scoped>
.profil {
  min-height: 100%;
  background: #0a1224;
}

.profil-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.profil-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.profil-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

/* identitas */
.profil-identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 16px 20px 16px;
}

.profil-avatar-wrap {
  position: relative;
  border-radius: 50%;
  padding: 4px;
  background: #0a1224;
  border: 2px solid #1e2c4f;
  transition: border-color 0.2s ease;
}

.profil-avatar-wrap--hover {
  border-color: #3b82f6;
}

.profil-avatar-overlay {
  position: absolute;
  inset: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.55);
  border-radius: 50%;
}

.profil-name {
  margin-top: 14px;
  font-size: 16px;
  font-weight: 700;
  color: #e2e8f0;
  text-align: center;
}

.profil-email {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

.profil-level {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  padding: 3px 14px;
  border-radius: 999px;
  border: 1px solid #1e2c4f;
  background: #0a1224;
  font-size: 11px;
  font-weight: 600;
  color: #93c5fd;
  text-transform: capitalize;
}

.profil-divider {
  height: 1px;
  background: #1e2c4f;
  margin: 0 16px;
}

/* form */
.profil-form {
  padding: 20px;
}

.profil-form-footer {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #1e2c4f;
}

.profil-form-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
}

.profil-btn-save {
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
  box-shadow: 0 8px 20px rgba(29, 78, 216, 0.35);
}
</style>
